import { render } from "./InnerImageZoom.vue?vue&type=template&id=49e1ea2c&scoped=true"
import script from "./InnerImageZoom.vue?vue&type=script&lang=js"
export * from "./InnerImageZoom.vue?vue&type=script&lang=js"

import "./InnerImageZoom.vue?vue&type=style&index=0&id=49e1ea2c&scoped=true&lang=css"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e1ea2c"]])

export default __exports__